import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "view", "className"];
import React from 'react';
import { Layer } from '../../types';
import { AbcRow } from './AbcRow';
import { AtushkaRow } from './AtushkaRow';
import { ChatRow } from './ChatRow';
import { CalendarRow } from './CalendarRow';
import { CaptionRow } from './CaptionRow';
import { DocRow } from './DocRow';
import { GoalsRow } from './GoalsRow';
import { GroupRow } from './GroupRow';
import { HelpRow } from './HelpRow';
import { IssueRow } from './IssueRow';
import { MLRow } from './MLRow';
import { MapRow } from './MapRow';
import { NpmRow } from './NpmRow';
import { Row } from './Row';
import { StackoverflowRow } from './StackoverflowRow';
import { StaffRow } from './StaffRow';
import { WikiRow } from './WikiRow';
import { SearchItemRole } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchListRow(_ref) {
  var item = _ref.item,
    view = _ref.view,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (item.role === SearchItemRole.Caption) {
    return /*#__PURE__*/_jsx(CaptionRow, {
      item: item,
      view: view,
      className: className
    });
  }
  var commonProps = _objectSpread({
    view: view,
    className: className
  }, otherProps);
  switch (item.layer) {
    case Layer.WIKI:
      return /*#__PURE__*/_jsx(WikiRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.PEOPLE:
      return /*#__PURE__*/_jsx(StaffRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.ISSUES:
      return /*#__PURE__*/_jsx(IssueRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.DOC:
      return /*#__PURE__*/_jsx(DocRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.ATUSHKA:
      return /*#__PURE__*/_jsx(AtushkaRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.MAP:
      return /*#__PURE__*/_jsx(MapRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.ABC:
      return /*#__PURE__*/_jsx(AbcRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.GOALS:
      return /*#__PURE__*/_jsx(GoalsRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.CALENDAR:
      return /*#__PURE__*/_jsx(CalendarRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.STACKOVERFLOW:
      return /*#__PURE__*/_jsx(StackoverflowRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.NPM:
      return /*#__PURE__*/_jsx(NpmRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.HELP:
      return /*#__PURE__*/_jsx(HelpRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.ML:
      return /*#__PURE__*/_jsx(MLRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.GROUPS:
      return /*#__PURE__*/_jsx(GroupRow, _objectSpread({
        item: item
      }, commonProps));
    case Layer.CHAT:
      return /*#__PURE__*/_jsx(ChatRow, _objectSpread({
        item: item
      }, commonProps));
    default:
      return /*#__PURE__*/_jsx(Row, _objectSpread({
        item: item
      }, commonProps));
  }
}
// #sourceMappingURL=SearchListRow.js.map